import { apiFetch } from "@/lib/api/client";
import type { SupportingDocumentRecord } from "@/types";

export async function fetchSupportingDocuments(
  reviewId: string
): Promise<SupportingDocumentRecord[]> {
  return apiFetch<SupportingDocumentRecord[]>(
    `/api/reviews/${encodeURIComponent(reviewId)}/supporting-documents`
  );
}

export async function deleteSupportingDocument(docId: string): Promise<void> {
  await apiFetch(`/api/review-supporting-documents/${encodeURIComponent(docId)}`, {
    method: "DELETE",
  });
}

export async function getSupportingDocumentDownloadUrl(
  storagePath: string | null | undefined
): Promise<string | null> {
  if (!storagePath) return null;
  try {
    const { downloadUrl } = await apiFetch<{ downloadUrl: string }>(
      `/api/storage/download-url?path=${encodeURIComponent(storagePath)}&bucket=contracts`
    );
    return downloadUrl;
  } catch {
    return null;
  }
}
